import { render, staticRenderFns } from "./startCarReplace.vue?vue&type=template&id=44b27895&scoped=true"
import script from "./startCarReplace.vue?vue&type=script&setup=true&lang=js"
export * from "./startCarReplace.vue?vue&type=script&setup=true&lang=js"
import style0 from "./startCarReplace.vue?vue&type=style&index=0&id=44b27895&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b27895",
  null
  
)

export default component.exports